export function getSpecificPostParams(paramname: string, querystring: string) {
    const params = new URLSearchParams(querystring)
    if (params.has(paramname)) {
        return params.get(paramname)
    }
    return null
}

import type { NavigationList, NavigationFamily, NavigationItem } from '@/types'

export function findNavigationObject(
  array: NavigationList | NavigationFamily[] | NavigationItem[],
  id: string
): NavigationFamily | NavigationItem | undefined {
  for (const item of array) {
    // @ts-ignore
    if (!item.separator) {
      const nacItem = item as NavigationItem
      // @ts-ignore
      if (nacItem.route?.params?.section === id) return nacItem
      if (nacItem.items?.length) {
        const innerResult = findNavigationObject(nacItem.items, id)
        if (innerResult) return innerResult
      }
    }
  }
}

export const toKebabCase = (key: string): string => {
  return key.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()
}

export const transformKeysToKebabCase = (obj: Record<string, any>): Record<string, any> => {
  return Object.keys(obj).reduce(
    (acc, key) => {
      const kebabKey = toKebabCase(key)
      acc[kebabKey] = obj[key]
      return acc
    },
    {} as Record<string, any>
  )
}
